import { render } from "./ResourceTable.vue?vue&type=template&id=0239d748"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTable.vue"]])

export default __exports__